export default __webpack_public_path__ + "static/media/sprint-invite-formulation.dc1c7962.pdf";